export default __webpack_public_path__ + "static/media/Laboratories.d58493dd.png";